export const environment = {
  production: false,
  apiUrl: 'https://dev.uaxi.mx/api/v1',
  socketUrl: 'https://dev.uaxi.mx',
  socketGatewayOrigin: undefined as string | undefined,
  ASSETS_URL: 'https://uaxis3.s3.us-east-1.amazonaws.com/uaxis3/',
  urlUbica: 'https://ubica.acodestudio.com.mx/',
  googleMapsApiKey: 'AIzaSyD5uXYuRgFLxeYfUrT0eNvC0efN1Ug_hqA',
};
